export { default } from './Resources';
